import React from 'react';
import { getContractLatestList } from 'api/common';
import { TContractLatestItem } from 'types/common';

let globalData:TContractLatestItem[] = [];

const useContractLatestList = ():[TContractLatestItem[], boolean, ()=>void] => {
    const loading = React.useRef(false);
    const [items, setItems] = React.useState<TContractLatestItem[]>(globalData);
    const fetchData = async () => {
        try {
            loading.current = true;
            const result = await getContractLatestList();
            if (!result.error) {
                const data:TContractLatestItem[] = result?.data?.data || [];
                globalData = data;
                setItems(data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        if (!loading.current) {
            fetchData();
        }
    }, []);

    return [items, loading.current, fetchData];
};

export default useContractLatestList;
